import { Controller } from "@hotwired/stimulus";

/** Remove-intermediary modal: selection, nested history options, and submit state. */
export default class extends Controller {
  static targets = [
    "submitButton",
    "option",
    "historyPanel",
    "submitLabelA",
    "submitLabelB",
    "consent",
    "consentCheckbox"
  ];

  connect() {
    this.reset = this.reset.bind(this);
    this.element.addEventListener("close", this.reset);
    this.reset();
  }

  disconnect() {
    this.element.removeEventListener("close", this.reset);
  }

  reset() {
    this.element.querySelectorAll("input[type=radio]").forEach((radio) => {
      radio.checked = false;
    });
    const box = this.consentCheckbox();
    if (box) box.checked = false;
    this.sync();
  }

  sync() {
    this.optionTargets.forEach((option) => {
      option.classList.toggle(
        "is-selected",
        Boolean(option.querySelector(".remove-intermediary-mode:checked"))
      );
    });

    const selected = this.modeRadio();
    const optionB = selected?.value === "intermediary_and_producers";

    const mode = this.element.querySelector("input[name='removal_mode']");
    if (mode) mode.value = selected ? selected.value : "";

    if (optionB) {
      this.ensureHistorySelection();
    } else {
      this.element.querySelectorAll(".remove-intermediary-history").forEach((radio) => {
        radio.checked = false;
      });
    }

    const history = this.element.querySelector(".remove-intermediary-history:checked");
    const historyField = this.element.querySelector("input[name='historical_data']");
    if (historyField) historyField.value = optionB ? (history?.value || "keep") : "";

    const deleting = history?.value === "delete";
    if (!deleting) {
      const box = this.consentCheckbox();
      if (box) box.checked = false;
    }

    this.optionBRadio()?.setAttribute("aria-expanded", optionB ? "true" : "false");

    if (this.hasHistoryPanelTarget) this.historyPanelTarget.hidden = !optionB;
    if (this.hasConsentTarget) this.consentTarget.hidden = !(optionB && deleting);

    if (this.hasSubmitLabelATarget) this.submitLabelATarget.hidden = optionB;
    if (this.hasSubmitLabelBTarget) this.submitLabelBTarget.hidden = !optionB;

    if (!this.hasSubmitButtonTarget) return;
    const ok = this.canSubmit();
    this.submitButtonTarget.disabled = !ok;
    this.submitButtonTarget.setAttribute("aria-disabled", ok ? "false" : "true");
  }

  canSubmit() {
    const selected = this.modeRadio();
    if (!selected) return false;
    if (selected.value === "intermediary_only") return true;
    if (selected.value !== "intermediary_and_producers") return false;

    const history = this.element.querySelector(".remove-intermediary-history:checked");
    if (history?.value !== "delete") return true;

    return Boolean(this.consentCheckbox()?.checked);
  }

  modeRadio() {
    return this.element.querySelector(".remove-intermediary-mode:checked");
  }

  optionBRadio() {
    return this.element.querySelector(".remove-intermediary-mode[value='intermediary_and_producers']");
  }

  ensureHistorySelection() {
    if (this.element.querySelector(".remove-intermediary-history:checked")) return;
    const keep = this.element.querySelector(".remove-intermediary-history[value='keep']");
    if (keep) keep.checked = true;
  }

  consentCheckbox() {
    if (this.hasConsentCheckboxTarget) return this.consentCheckboxTarget;
    return this.element.querySelector(".remove-intermediary-delete-consent-checkbox");
  }
}
